define(function () {

    return addTrackingPixel;

    function addTrackingPixel(url) {
        new Image().src = url;
    }

});



//////////////////
// WEBPACK FOOTER
// ./static/src/javascripts-legacy/projects/commercial/modules/creatives/add-tracking-pixel.js
// module id = 392
// module chunks = 1